export enum AbilityEnum {
  MY_GIFTCARDS_PAGE = 'MY_GIFTCARDS_PAGE',
  BUY_GIFTCARDS_PAGE = 'BUY_GIFTCARDS_PAGE',
}
